(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.RsStorage = {}));
})(this, (function (exports) { 'use strict';

	var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

	function unwrapExports (x) {
		return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
	}

	function createCommonjsModule(fn, module) {
		return module = { exports: {} }, fn(module, module.exports), module.exports;
	}

	var setPrototypeOf = createCommonjsModule(function (module) {
	function _setPrototypeOf(o, p) {
	  module.exports = _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
	    o.__proto__ = p;
	    return o;
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
	  return _setPrototypeOf(o, p);
	}
	module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;
	});
	unwrapExports(setPrototypeOf);

	var inherits = createCommonjsModule(function (module) {
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      writable: true,
	      configurable: true
	    }
	  });
	  Object.defineProperty(subClass, "prototype", {
	    writable: false
	  });
	  if (superClass) setPrototypeOf(subClass, superClass);
	}
	module.exports = _inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;
	});
	var _inherits = unwrapExports(inherits);

	var _typeof_1 = createCommonjsModule(function (module) {
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	  return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
	    return typeof obj;
	  } : function (obj) {
	    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(obj);
	}
	module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;
	});
	unwrapExports(_typeof_1);

	var assertThisInitialized = createCommonjsModule(function (module) {
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	  return self;
	}
	module.exports = _assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;
	});
	unwrapExports(assertThisInitialized);

	var possibleConstructorReturn = createCommonjsModule(function (module) {
	var _typeof = _typeof_1["default"];
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  } else if (call !== void 0) {
	    throw new TypeError("Derived constructors may only return object or undefined");
	  }
	  return assertThisInitialized(self);
	}
	module.exports = _possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;
	});
	var _possibleConstructorReturn = unwrapExports(possibleConstructorReturn);

	var getPrototypeOf = createCommonjsModule(function (module) {
	function _getPrototypeOf(o) {
	  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
	  return _getPrototypeOf(o);
	}
	module.exports = _getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;
	});
	var _getPrototypeOf = unwrapExports(getPrototypeOf);

	var classCallCheck = createCommonjsModule(function (module) {
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	module.exports = _classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;
	});
	var _classCallCheck = unwrapExports(classCallCheck);

	var toPrimitive = createCommonjsModule(function (module) {
	var _typeof = _typeof_1["default"];
	function _toPrimitive(input, hint) {
	  if (_typeof(input) !== "object" || input === null) return input;
	  var prim = input[Symbol.toPrimitive];
	  if (prim !== undefined) {
	    var res = prim.call(input, hint || "default");
	    if (_typeof(res) !== "object") return res;
	    throw new TypeError("@@toPrimitive must return a primitive value.");
	  }
	  return (hint === "string" ? String : Number)(input);
	}
	module.exports = _toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;
	});
	unwrapExports(toPrimitive);

	var toPropertyKey = createCommonjsModule(function (module) {
	var _typeof = _typeof_1["default"];
	function _toPropertyKey(arg) {
	  var key = toPrimitive(arg, "string");
	  return _typeof(key) === "symbol" ? key : String(key);
	}
	module.exports = _toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;
	});
	unwrapExports(toPropertyKey);

	var createClass = createCommonjsModule(function (module) {
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];
	    descriptor.enumerable = descriptor.enumerable || false;
	    descriptor.configurable = true;
	    if ("value" in descriptor) descriptor.writable = true;
	    Object.defineProperty(target, toPropertyKey(descriptor.key), descriptor);
	  }
	}
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	  if (staticProps) _defineProperties(Constructor, staticProps);
	  Object.defineProperty(Constructor, "prototype", {
	    writable: false
	  });
	  return Constructor;
	}
	module.exports = _createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;
	});
	var _createClass = unwrapExports(createClass);

	var loglevel = createCommonjsModule(function (module) {
	(function (root, definition) {
	    if (module.exports) {
	        module.exports = definition();
	    } else {
	        root.log = definition();
	    }
	}(commonjsGlobal, function () {
	    var noop = function() {};
	    var undefinedType = "undefined";
	    var isIE = (typeof window !== undefinedType) && (typeof window.navigator !== undefinedType) && (
	        /Trident\/|MSIE /.test(window.navigator.userAgent)
	    );
	    var logMethods = [
	        "trace",
	        "debug",
	        "info",
	        "warn",
	        "error"
	    ];
	    function bindMethod(obj, methodName) {
	        var method = obj[methodName];
	        if (typeof method.bind === 'function') {
	            return method.bind(obj);
	        } else {
	            try {
	                return Function.prototype.bind.call(method, obj);
	            } catch (e) {
	                return function() {
	                    return Function.prototype.apply.apply(method, [obj, arguments]);
	                };
	            }
	        }
	    }
	    function traceForIE() {
	        if (console.log) {
	            if (console.log.apply) {
	                console.log.apply(console, arguments);
	            } else {
	                Function.prototype.apply.apply(console.log, [console, arguments]);
	            }
	        }
	        if (console.trace) console.trace();
	    }
	    function realMethod(methodName) {
	        if (methodName === 'debug') {
	            methodName = 'log';
	        }
	        if (typeof console === undefinedType) {
	            return false;
	        } else if (methodName === 'trace' && isIE) {
	            return traceForIE;
	        } else if (console[methodName] !== undefined) {
	            return bindMethod(console, methodName);
	        } else if (console.log !== undefined) {
	            return bindMethod(console, 'log');
	        } else {
	            return noop;
	        }
	    }
	    function replaceLoggingMethods(level, loggerName) {
	        for (var i = 0; i < logMethods.length; i++) {
	            var methodName = logMethods[i];
	            this[methodName] = (i < level) ?
	                noop :
	                this.methodFactory(methodName, level, loggerName);
	        }
	        this.log = this.debug;
	    }
	    function enableLoggingWhenConsoleArrives(methodName, level, loggerName) {
	        return function () {
	            if (typeof console !== undefinedType) {
	                replaceLoggingMethods.call(this, level, loggerName);
	                this[methodName].apply(this, arguments);
	            }
	        };
	    }
	    function defaultMethodFactory(methodName, level, loggerName) {
	        return realMethod(methodName) ||
	               enableLoggingWhenConsoleArrives.apply(this, arguments);
	    }
	    function Logger(name, defaultLevel, factory) {
	      var self = this;
	      var currentLevel;
	      defaultLevel = defaultLevel == null ? "WARN" : defaultLevel;
	      var storageKey = "loglevel";
	      if (typeof name === "string") {
	        storageKey += ":" + name;
	      } else if (typeof name === "symbol") {
	        storageKey = undefined;
	      }
	      function persistLevelIfPossible(levelNum) {
	          var levelName = (logMethods[levelNum] || 'silent').toUpperCase();
	          if (typeof window === undefinedType || !storageKey) return;
	          try {
	              window.localStorage[storageKey] = levelName;
	              return;
	          } catch (ignore) {}
	          try {
	              window.document.cookie =
	                encodeURIComponent(storageKey) + "=" + levelName + ";";
	          } catch (ignore) {}
	      }
	      function getPersistedLevel() {
	          var storedLevel;
	          if (typeof window === undefinedType || !storageKey) return;
	          try {
	              storedLevel = window.localStorage[storageKey];
	          } catch (ignore) {}
	          if (typeof storedLevel === undefinedType) {
	              try {
	                  var cookie = window.document.cookie;
	                  var location = cookie.indexOf(
	                      encodeURIComponent(storageKey) + "=");
	                  if (location !== -1) {
	                      storedLevel = /^([^;]+)/.exec(cookie.slice(location))[1];
	                  }
	              } catch (ignore) {}
	          }
	          if (self.levels[storedLevel] === undefined) {
	              storedLevel = undefined;
	          }
	          return storedLevel;
	      }
	      function clearPersistedLevel() {
	          if (typeof window === undefinedType || !storageKey) return;
	          try {
	              window.localStorage.removeItem(storageKey);
	              return;
	          } catch (ignore) {}
	          try {
	              window.document.cookie =
	                encodeURIComponent(storageKey) + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC";
	          } catch (ignore) {}
	      }
	      self.name = name;
	      self.levels = { "TRACE": 0, "DEBUG": 1, "INFO": 2, "WARN": 3,
	          "ERROR": 4, "SILENT": 5};
	      self.methodFactory = factory || defaultMethodFactory;
	      self.getLevel = function () {
	          return currentLevel;
	      };
	      self.setLevel = function (level, persist) {
	          if (typeof level === "string" && self.levels[level.toUpperCase()] !== undefined) {
	              level = self.levels[level.toUpperCase()];
	          }
	          if (typeof level === "number" && level >= 0 && level <= self.levels.SILENT) {
	              currentLevel = level;
	              if (persist !== false) {
	                  persistLevelIfPossible(level);
	              }
	              replaceLoggingMethods.call(self, level, name);
	              if (typeof console === undefinedType && level < self.levels.SILENT) {
	                  return "No console available for logging";
	              }
	          } else {
	              throw "log.setLevel() called with invalid level: " + level;
	          }
	      };
	      self.setDefaultLevel = function (level) {
	          defaultLevel = level;
	          if (!getPersistedLevel()) {
	              self.setLevel(level, false);
	          }
	      };
	      self.resetLevel = function () {
	          self.setLevel(defaultLevel, false);
	          clearPersistedLevel();
	      };
	      self.enableAll = function(persist) {
	          self.setLevel(self.levels.TRACE, persist);
	      };
	      self.disableAll = function(persist) {
	          self.setLevel(self.levels.SILENT, persist);
	      };
	      var initialLevel = getPersistedLevel();
	      if (initialLevel == null) {
	          initialLevel = defaultLevel;
	      }
	      self.setLevel(initialLevel, false);
	    }
	    var defaultLogger = new Logger();
	    var _loggersByName = {};
	    defaultLogger.getLogger = function getLogger(name) {
	        if ((typeof name !== "symbol" && typeof name !== "string") || name === "") {
	          throw new TypeError("You must supply a name when creating a logger.");
	        }
	        var logger = _loggersByName[name];
	        if (!logger) {
	          logger = _loggersByName[name] = new Logger(
	            name, defaultLogger.getLevel(), defaultLogger.methodFactory);
	        }
	        return logger;
	    };
	    var _log = (typeof window !== undefinedType) ? window.log : undefined;
	    defaultLogger.noConflict = function() {
	        if (typeof window !== undefinedType &&
	               window.log === defaultLogger) {
	            window.log = _log;
	        }
	        return defaultLogger;
	    };
	    defaultLogger.getLoggers = function getLoggers() {
	        return _loggersByName;
	    };
	    defaultLogger['default'] = defaultLogger;
	    return defaultLogger;
	}));
	});

	var toString$1 = Object.prototype.toString;
	var componentType = function(val){
	  switch (toString$1.call(val)) {
	    case '[object Date]': return 'date';
	    case '[object RegExp]': return 'regexp';
	    case '[object Arguments]': return 'arguments';
	    case '[object Array]': return 'array';
	    case '[object Error]': return 'error';
	  }
	  if (val === null) return 'null';
	  if (val === undefined) return 'undefined';
	  if (val !== val) return 'nan';
	  if (val && val.nodeType === 1) return 'element';
	  val = val.valueOf
	    ? val.valueOf()
	    : Object.prototype.valueOf.apply(val);
	  return typeof val;
	};

	var toString = Object.prototype.toString;
	var isPlainObj = function (x) {
		var prototype;
		return toString.call(x) === '[object Object]' && (prototype = Object.getPrototypeOf(x), prototype === null || prototype === Object.getPrototypeOf({}));
	};

	var lib$1 = createCommonjsModule(function (module, exports) {
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = range;
	var _isPlainObj2 = _interopRequireDefault(isPlainObj);
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	function range(opts) {
	  var IDBKeyRange = commonjsGlobal.IDBKeyRange || commonjsGlobal.webkitIDBKeyRange;
	  if (opts instanceof IDBKeyRange) return opts;
	  if (typeof opts === 'undefined' || opts === null) return null;
	  if (!(0, _isPlainObj2.default)(opts)) return IDBKeyRange.only(opts);
	  var keys = Object.keys(opts).sort();
	  if (keys.length === 1) {
	    var key = keys[0];
	    var val = opts[key];
	    switch (key) {
	      case 'eq':
	        return IDBKeyRange.only(val);
	      case 'gt':
	        return IDBKeyRange.lowerBound(val, true);
	      case 'lt':
	        return IDBKeyRange.upperBound(val, true);
	      case 'gte':
	        return IDBKeyRange.lowerBound(val);
	      case 'lte':
	        return IDBKeyRange.upperBound(val);
	      default:
	        throw new TypeError('"' + key + '" is not valid key');
	    }
	  } else {
	    var x = opts[keys[0]];
	    var y = opts[keys[1]];
	    var pattern = keys.join('-');
	    switch (pattern) {
	      case 'gt-lt':
	        return IDBKeyRange.bound(x, y, true, true);
	      case 'gt-lte':
	        return IDBKeyRange.bound(x, y, true, false);
	      case 'gte-lt':
	        return IDBKeyRange.bound(x, y, false, true);
	      case 'gte-lte':
	        return IDBKeyRange.bound(x, y, false, false);
	      default:
	        throw new TypeError('"' + pattern + '" are conflicted keys');
	    }
	  }
	}
	module.exports = exports['default'];
	});
	unwrapExports(lib$1);

	var idbStore = Store;
	function Store(name, opts) {
	  this.db = null;
	  this.name = name;
	  this.indexes = {};
	  this.opts = opts;
	  this.key = opts.key || opts.keyPath || undefined;
	  this.increment = opts.increment || opts.autoIncretement || undefined;
	}
	Store.prototype.index = function(name) {
	  return this.indexes[name];
	};
	Store.prototype.put = function(key, val, cb) {
	  var name = this.name;
	  var keyPath = this.key;
	  if (keyPath) {
	    if (componentType(key) == 'object') {
	      cb = val;
	      val = key;
	      key = null;
	    } else {
	      val[keyPath] = key;
	    }
	  }
	  this.db.transaction('readwrite', [name], function(err, tr) {
	    if (err) return cb(err);
	    var objectStore = tr.objectStore(name);
	    var req = keyPath ? objectStore.put(val) : objectStore.put(val, key);
	    tr.onerror = tr.onabort = req.onerror = cb;
	    tr.oncomplete = function oncomplete() { cb(null, req.result); };
	  });
	};
	Store.prototype.get = function(key, cb) {
	  var name = this.name;
	  this.db.transaction('readonly', [name], function(err, tr) {
	    if (err) return cb(err);
	    var objectStore = tr.objectStore(name);
	    var req = objectStore.get(key);
	    req.onerror = cb;
	    req.onsuccess = function onsuccess(e) { cb(null, e.target.result); };
	  });
	};
	Store.prototype.del = function(key, cb) {
	  var name = this.name;
	  this.db.transaction('readwrite', [name], function(err, tr) {
	    if (err) return cb(err);
	    var objectStore = tr.objectStore(name);
	    var req = objectStore.delete(key);
	    tr.onerror = tr.onabort = req.onerror = cb;
	    tr.oncomplete = function oncomplete() { cb(); };
	  });
	};
	Store.prototype.count = function(cb) {
	  var name = this.name;
	  this.db.transaction('readonly', [name], function(err, tr) {
	    if (err) return cb(err);
	    var objectStore = tr.objectStore(name);
	    var req = objectStore.count();
	    req.onerror = cb;
	    req.onsuccess = function onsuccess(e) { cb(null, e.target.result); };
	  });
	};
	Store.prototype.clear = function(cb) {
	  var name = this.name;
	  this.db.transaction('readwrite', [name], function(err, tr) {
	    if (err) return cb(err);
	    var objectStore = tr.objectStore(name);
	    var req = objectStore.clear();
	    tr.onerror = tr.onabort = req.onerror = cb;
	    tr.oncomplete = function oncomplete() { cb(); };
	  });
	};
	Store.prototype.batch = function(vals, cb) {
	  var name = this.name;
	  var keyPath = this.key;
	  var keys = Object.keys(vals);
	  this.db.transaction('readwrite', [name], function(err, tr) {
	    if (err) return cb(err);
	    var store = tr.objectStore(name);
	    var current = 0;
	    tr.onerror = tr.onabort = cb;
	    tr.oncomplete = function oncomplete() { cb(); };
	    next();
	    function next() {
	      if (current >= keys.length) return;
	      var currentKey = keys[current];
	      var currentVal = vals[currentKey];
	      var req;
	      if (currentVal === null) {
	        req = store.delete(currentKey);
	      } else if (keyPath) {
	        if (!currentVal[keyPath]) currentVal[keyPath] = currentKey;
	        req = store.put(currentVal);
	      } else {
	        req = store.put(currentVal, currentKey);
	      }
	      req.onerror = cb;
	      req.onsuccess = next;
	      current += 1;
	    }
	  });
	};
	Store.prototype.all = function(cb) {
	  var result = [];
	  this.cursor({ iterator: iterator }, function(err) {
	    err ? cb(err) : cb(null, result);
	  });
	  function iterator(cursor) {
	    result.push(cursor.value);
	    cursor.continue();
	  }
	};
	Store.prototype.cursor = function(opts, cb) {
	  var name = this.name;
	  this.db.transaction('readonly', [name], function(err, tr) {
	    if (err) return cb(err);
	    var store = opts.index
	      ? tr.objectStore(name).index(opts.index)
	      : tr.objectStore(name);
	    var req = store.openCursor(lib$1(opts.range));
	    req.onerror = cb;
	    req.onsuccess = function onsuccess(e) {
	      var cursor = e.target.result;
	      cursor ? opts.iterator(cursor) : cb();
	    };
	  });
	};

	var idbIndex = Index;
	function Index(store, name, field, opts) {
	  this.store = store;
	  this.name = name;
	  this.field = field;
	  this.opts = opts;
	  this.multi = opts.multi || opts.multiEntry || false;
	  this.unique = opts.unique || false;
	}
	Index.prototype.get = function(key, cb) {
	  var result = [];
	  var isUnique = this.unique;
	  var opts = { range: key, iterator: iterator };
	  this.cursor(opts, function(err) {
	    if (err) return cb(err);
	    isUnique ? cb(null, result[0]) : cb(null, result);
	  });
	  function iterator(cursor) {
	    result.push(cursor.value);
	    cursor.continue();
	  }
	};
	Index.prototype.count = function(key, cb) {
	  var name = this.store.name;
	  var indexName = this.name;
	  this.store.db.transaction('readonly', [name], function(err, tr) {
	    if (err) return cb(err);
	    var index = tr.objectStore(name).index(indexName);
	    var req = index.count(lib$1(key));
	    req.onerror = cb;
	    req.onsuccess = function onsuccess(e) { cb(null, e.target.result); };
	  });
	};
	Index.prototype.cursor = function(opts, cb) {
	  opts.index = this.name;
	  this.store.cursor(opts, cb);
	};

	var schema = Schema;
	function Schema() {
	  if (!(this instanceof Schema)) return new Schema();
	  this._stores = {};
	  this._current = {};
	  this._versions = {};
	}
	Schema.prototype.version = function(version) {
	  if (componentType(version) != 'number' || version < 1 || version < this.getVersion())
	    throw new TypeError('not valid version');
	  this._current = { version: version, store: null };
	  this._versions[version] = {
	    stores: [],
	    dropStores: [],
	    indexes: [],
	    dropIndexes: [],
	    version: version
	  };
	  return this;
	};
	Schema.prototype.addStore = function(name, opts) {
	  if (componentType(name) != 'string') throw new TypeError('`name` is required');
	  if (this._stores[name]) throw new TypeError('store is already defined');
	  var store = new idbStore(name, opts || {});
	  this._stores[name] = store;
	  this._versions[this.getVersion()].stores.push(store);
	  this._current.store = store;
	  return this;
	};
	Schema.prototype.dropStore = function(name) {
	  if (componentType(name) != 'string') throw new TypeError('`name` is required');
	  var store = this._stores[name];
	  if (!store) throw new TypeError('store is not defined');
	  delete this._stores[name];
	  this._versions[this.getVersion()].dropStores.push(store);
	  return this;
	};
	Schema.prototype.addIndex = function(name, field, opts) {
	  if (componentType(name) != 'string') throw new TypeError('`name` is required');
	  if (componentType(field) != 'string' && componentType(field) != 'array') throw new TypeError('`field` is required');
	  var store = this._current.store;
	  if (store.indexes[name]) throw new TypeError('index is already defined');
	  var index = new idbIndex(store, name, field, opts || {});
	  store.indexes[name] = index;
	  this._versions[this.getVersion()].indexes.push(index);
	  return this;
	};
	Schema.prototype.dropIndex = function(name) {
	  if (componentType(name) != 'string') throw new TypeError('`name` is required');
	  var index = this._current.store.indexes[name];
	  if (!index) throw new TypeError('index is not defined');
	  delete this._current.store.indexes[name];
	  this._versions[this.getVersion()].dropIndexes.push(index);
	  return this;
	};
	Schema.prototype.getStore = function(name) {
	  if (componentType(name) != 'string') throw new TypeError('`name` is required');
	  if (!this._stores[name]) throw new TypeError('store is not defined');
	  this._current.store = this._stores[name];
	  return this;
	};
	Schema.prototype.getVersion = function() {
	  return this._current.version;
	};
	Schema.prototype.callback = function() {
	  var versions = Object.keys(this._versions)
	    .map(function(v) { return this._versions[v] }, this)
	    .sort(function(a, b) { return a.version - b.version });
	  return function onupgradeneeded(e) {
	    var db = e.target.result;
	    var tr = e.target.transaction;
	    versions.forEach(function(versionSchema) {
	      if (e.oldVersion >= versionSchema.version) return;
	      versionSchema.stores.forEach(function(s) {
	        var options = {};
	        if (typeof s.key !== 'undefined') options.keyPath = s.key;
	        if (typeof s.increment !== 'undefined') options.autoIncrement = s.increment;
	        db.createObjectStore(s.name, options);
	      });
	      versionSchema.dropStores.forEach(function(s) {
	        db.deleteObjectStore(s.name);
	      });
	      versionSchema.indexes.forEach(function(i) {
	        var store = tr.objectStore(i.store.name);
	        store.createIndex(i.name, i.field, {
	          unique: i.unique,
	          multiEntry: i.multi
	        });
	      });
	      versionSchema.dropIndexes.forEach(function(i) {
	        var store = tr.objectStore(i.store.name);
	        store.deleteIndex(i.name);
	      });
	    });
	  };
	};

	var lib = createCommonjsModule(function (module, exports) {
	exports = module.exports = Treo;
	function Treo(name, schema$1) {
	  if (!(this instanceof Treo)) return new Treo(name, schema$1);
	  if (componentType(name) != 'string') throw new TypeError('`name` required');
	  if (!(schema$1 instanceof schema)) throw new TypeError('not valid schema');
	  this.name = name;
	  this.status = 'close';
	  this.origin = null;
	  this.stores = schema$1._stores;
	  this.version = schema$1.getVersion();
	  this.onupgradeneeded = schema$1.callback();
	  Object.keys(this.stores).forEach(function(storeName) {
	    this.stores[storeName].db = this;
	  }, this);
	}
	exports.schema = schema;
	exports.cmp = cmp;
	exports.Treo = Treo;
	exports.Schema = schema;
	exports.Store = idbStore;
	exports.Index = idbIndex;
	Treo.prototype.use = function(fn) {
	  fn(this, exports);
	  return this;
	};
	Treo.prototype.drop = function(cb) {
	  var name = this.name;
	  this.close(function(err) {
	    if (err) return cb(err);
	    var req = indexedDB().deleteDatabase(name);
	    req.onerror = cb;
	    req.onsuccess = function onsuccess() { cb(); };
	  });
	};
	Treo.prototype.close = function(cb) {
	  if (this.status == 'close') return cb();
	  this.getInstance(function(err, db) {
	    if (err) return cb(err);
	    db.origin = null;
	    db.status = 'close';
	    db.close();
	    cb();
	  });
	};
	Treo.prototype.store = function(name) {
	  return this.stores[name];
	};
	Treo.prototype.getInstance = function(cb) {
	  if (this.status == 'open') return cb(null, this.origin);
	  if (this.status == 'opening') return this.queue.push(cb);
	  this.status = 'opening';
	  this.queue = [cb];
	  var that = this;
	  var req = indexedDB().open(this.name, this.version);
	  req.onupgradeneeded = this.onupgradeneeded;
	  req.onerror = req.onblocked = function onerror(e) {
	    that.status = 'error';
	    that.queue.forEach(function(cb) { cb(e); });
	    delete that.queue;
	  };
	  req.onsuccess = function onsuccess(e) {
	    that.origin = e.target.result;
	    that.status = 'open';
	    that.origin.onversionchange = function onversionchange() {
	      that.close(function() {});
	    };
	    that.queue.forEach(function(cb) { cb(null, that.origin); });
	    delete that.queue;
	  };
	};
	Treo.prototype.transaction = function(type, stores, cb) {
	  this.getInstance(function(err, db) {
	    err ? cb(err) : cb(null, db.transaction(stores, type));
	  });
	};
	function cmp() {
	  return indexedDB().cmp.apply(indexedDB(), arguments);
	}
	function indexedDB() {
	  return commonjsGlobal._indexedDB
	    || commonjsGlobal.indexedDB
	    || commonjsGlobal.msIndexedDB
	    || commonjsGlobal.mozIndexedDB
	    || commonjsGlobal.webkitIndexedDB;
	}
	});
	lib.schema;
	lib.cmp;
	lib.Treo;
	lib.Schema;
	lib.Store;
	lib.Index;

	var logger = loglevel.getLogger('RSStorage:operations');
	logger.setLevel('warn');
	var EMAIL_BUCKETS = ['_email.id', '_email.tid'];
	var MSG_DB_VERSIONED_SCHEMA = [
	[{
	  name: '_id.list',
	  indexes: ['sift.guid']
	}, {
	  name: '_tid.list',
	  indexes: ['sift.guid']
	}],
	[{
	  name: '_email.id',
	  indexes: ['sift.guid']
	}, {
	  name: '_email.tid',
	  indexes: ['sift.guid']
	}, {
	  name: '_id.list',
	  drop: true
	}, {
	  name: '_tid.list',
	  drop: true
	}]];
	var SYNC_DB_SCHEMA = [{
	  name: 'events',
	  indexes: ['value.sift.guid']
	}, {
	  name: 'admin'
	}];
	var CLIENT_DB_SCHEMA = [{
	  name: 'tour'
	}, {
	  name: 'spm'
	}, {
	  name: 'auth'
	}];
	function opCreateDb(dbInfo) {
	  logger.trace('[opCreateDb]: ', dbInfo);
	  var dbs = {};
	  switch (dbInfo.type) {
	    case 'MSG':
	      dbs.msg = lib('rs_msg_db-' + dbInfo.accountGuid, _getVersionedTreoSchema(MSG_DB_VERSIONED_SCHEMA));
	      break;
	    case 'SIFT':
	      if (!dbInfo.siftGuid) {
	        throw new Error('[opCreateDb]: dbInfo.siftGuid undefined');
	      }
	      logger.trace('[opCreateDb]: creating SIFT db');
	      var schema = _getTreoSchema(dbInfo.schema, true);
	      schema = schema.addStore('_user.default').addStore('_redsift').addStore('_org');
	      dbs.db = lib(dbInfo.siftGuid + '-' + dbInfo.accountGuid, schema);
	      dbs.msg = lib('rs_msg_db-' + dbInfo.accountGuid, _getVersionedTreoSchema(MSG_DB_VERSIONED_SCHEMA));
	      break;
	    case 'SYNC':
	      logger.trace('[opCreateDb]: creating SYNC db');
	      dbs.db = lib('rs_sync_log-' + dbInfo.accountGuid, _getTreoSchema(SYNC_DB_SCHEMA));
	      break;
	    case 'CLIENT':
	      dbs.db = lib('rs_client_db-' + dbInfo.clientName, _getTreoSchema(CLIENT_DB_SCHEMA));
	      break;
	    default:
	      throw new Error('[opCreateDb]: unsupported db type: ' + dbInfo.type);
	  }
	  return dbs;
	}
	function opCursor(db, params, done) {
	  logger.trace('[opCursor]', params);
	  if (!params.bucket) {
	    throw new Error('[opCursor: params.bucket undefined');
	  } else {
	    var bucket = db.store(params.bucket);
	    bucket.cursor({
	      iterator: params.iterator
	    }, done);
	  }
	}
	function opDeleteDatabase(db) {
	  logger.trace('[opDeleteDatabase]');
	  return new Promise(function (resolve, reject) {
	    db.drop(function (err) {
	      if (!err) {
	        resolve();
	      } else {
	        reject(err);
	      }
	    });
	  });
	}
	function opDel(dbs, params, siftGuid) {
	  logger.trace('[opDel]: ', params, siftGuid);
	  if (!params.bucket) {
	    return Promise.reject('[opDel]: params.bucket undefined');
	  }
	  if (!params.keys || params.keys.length === 0) {
	    logger.trace('[opDel]: params.keys undefined');
	    return Promise.resolve();
	  }
	  if (EMAIL_BUCKETS.indexOf(params.bucket) !== -1) {
	    var keys = params.keys.map(function (k) {
	      return siftGuid + '/' + k;
	    });
	    return _batchDelete(dbs.msg, {
	      bucket: params.bucket,
	      keys: keys
	    });
	  }
	  return _batchDelete(dbs.db, params);
	}
	function opGet(dbs, params, siftGuid) {
	  logger.trace('[opGet]: ', params);
	  if (!params.bucket) {
	    return Promise.reject('[opGet]: params.bucket undefined');
	  }
	  if (!params.keys) {
	    return Promise.reject('[opGet]: param.keys undefined');
	  }
	  if (params.keys.length === 0) {
	    return Promise.resolve([]);
	  }
	  if (EMAIL_BUCKETS.indexOf(params.bucket) !== -1) {
	    var keys = params.keys.map(function (k) {
	      return siftGuid + '/' + k;
	    });
	    return _findIn(dbs.msg, {
	      bucket: params.bucket,
	      keys: keys
	    }).then(function (result) {
	      return result.map(function (r) {
	        return {
	          key: r.key.split('/')[1],
	          value: r.value
	        };
	      });
	    });
	  }
	  return _findIn(dbs.db, params);
	}
	function opGetAll(dbs, params, siftGuid) {
	  logger.trace('[opGetAll]: ', params, siftGuid);
	  if (!params.bucket) {
	    return Promise.reject('[opGetAll]: params.bucket undefined');
	  }
	  if (EMAIL_BUCKETS.indexOf(params.bucket) !== -1) {
	    return _getAll(dbs.msg, {
	      bucket: params.bucket,
	      index: 'sift.guid',
	      range: siftGuid
	    }, true).then(function (result) {
	      return result.map(function (r) {
	        return {
	          key: r.key.split('/')[1],
	          value: r.value
	        };
	      });
	    });
	  }
	  return _getAll(dbs.db, params, true);
	}
	function opGetAllKeys(dbs, params, siftGuid) {
	  logger.trace('[opGetAllKeys]: ', params, siftGuid);
	  if (!params.bucket) {
	    return Promise.reject('[opGetAllKeys]: params.bucket undefined');
	  }
	  if (EMAIL_BUCKETS.indexOf(params.bucket) !== -1) {
	    return _getAll(dbs.msg, {
	      bucket: params.bucket,
	      index: 'sift.guid',
	      range: siftGuid
	    }, false).then(function (result) {
	      return result.map(function (r) {
	        return r.key.split('/')[1];
	      });
	    });
	  }
	  return _getAll(dbs.db, params, false);
	}
	function opGetIndex(dbs, params, siftGuid) {
	  logger.trace('[opGetIndex]: ', params, siftGuid);
	  if (!params.bucket) {
	    return Promise.reject('[opGetIndex]:params.bucket undefined');
	  }
	  if (EMAIL_BUCKETS.indexOf(params.bucket) !== -1) {
	    return _getAll(dbs.msg, {
	      bucket: params.bucket,
	      index: 'sift.guid',
	      range: siftGuid
	    }, true).then(function (result) {
	      return result.map(function (r) {
	        return {
	          key: r.key.split('/')[1],
	          value: r.value
	        };
	      });
	    });
	  }
	  if (!params.index) {
	    return Promise.reject('[opGetIndex]:params.index undefined');
	  }
	  return _getAll(dbs.db, params, true);
	}
	function opGetIndexKeys(dbs, params, siftGuid) {
	  logger.trace('[opGetIndexKeys]: ', params, siftGuid);
	  if (!params.bucket) {
	    return Promise.reject('[opGetIndexKeys]: params.bucket undefined');
	  }
	  if (EMAIL_BUCKETS.indexOf(params.bucket) !== -1) {
	    return _getAll(dbs.msg, {
	      bucket: params.bucket,
	      index: 'sift.guid',
	      range: siftGuid
	    }, false).then(function (result) {
	      return result.map(function (r) {
	        return {
	          key: r.key.split('/')[1],
	          value: r.value
	        };
	      });
	    });
	  }
	  if (!params.index) {
	    return Promise.reject('[opGetIndexKeys]: params.index undefined');
	  }
	  return _getAll(dbs.db, params, false);
	}
	function opGetWithIndex(dbs, params, siftGuid) {
	  logger.trace('[opGetWithIndex]: ', params, siftGuid);
	  if (!params.bucket) {
	    return Promise.reject('[opGetWithIndex]:params.bucket undefined');
	  }
	  if (!params.keys) {
	    return Promise.reject('[opGetWithIndex]:params.keys undefined');
	  }
	  if (EMAIL_BUCKETS.indexOf(params.bucket) !== -1) {
	    var keys = params.keys.map(function (k) {
	      return siftGuid + '/' + k;
	    });
	    return _getWithIndexRange(dbs.msg, {
	      bucket: params.bucket,
	      keys: keys,
	      index: 'sift.guid',
	      range: siftGuid
	    }).then(function (result) {
	      return result.map(function (r) {
	        return {
	          key: r.key.split('/')[1],
	          value: r.value
	        };
	      });
	    });
	  }
	  if (!params.index) {
	    return Promise.reject('[opGetWithIndex]:params.index undefined');
	  }
	  if (!params.range) {
	    return Promise.reject('[opGetWithIndex]:params.range undefined');
	  }
	  return _getWithIndexRange(dbs.db, params);
	}
	function opPut(dbs, params, raw, siftGuid) {
	  logger.trace('[opPut]: ', params, raw, siftGuid);
	  var db = dbs.db;
	  if (!params.bucket) {
	    return Promise.reject('[opPut]: params.bucket undefined');
	  }
	  if (!params.kvs || params.kvs.length === 0) {
	    logger.warn('[opPut]: params.kvs undefined');
	    return Promise.resolve();
	  }
	  var kvs = params.kvs;
	  if (!raw) {
	    kvs = kvs.map(function (kv) {
	      return {
	        key: kv.key,
	        value: {
	          value: kv.value
	        }
	      };
	    });
	  }
	  if (EMAIL_BUCKETS.indexOf(params.bucket) !== -1) {
	    db = dbs.msg;
	    var kvs = kvs.map(function (kv) {
	      return {
	        key: siftGuid + '/' + kv.key,
	        value: kv.value
	      };
	    });
	  }
	  return _batchPut(db, {
	    bucket: params.bucket,
	    kvs: kvs
	  });
	}
	function opClose(dbs, cb) {
	  logger.trace('[opClose]');
	  if (!cb) {
	    cb = function cb() {};
	  }
	  dbs.db.close(cb);
	}
	function _getTreoSchema(stores, sift) {
	  logger.trace('[_getTreoSchema]: ', stores, sift);
	  var schema = lib.schema().version(1);
	  stores.forEach(function (os) {
	    if (!(sift && EMAIL_BUCKETS.indexOf(os.name) !== -1)) {
	      if (os.keypath) {
	        schema = schema.addStore(os.name, {
	          key: os.keypath
	        });
	      } else {
	        schema = schema.addStore(os.name);
	      }
	      if (os.indexes) {
	        os.indexes.forEach(function (idx) {
	          schema = schema.addIndex(idx, 'twoI.' + idx, {
	            unique: false
	          });
	        });
	      }
	    }
	  });
	  return schema;
	}
	function _getVersionedTreoSchema(versions, sift) {
	  logger.trace('[_getVersionedTreoSchema]: ', versions, sift);
	  var schema = lib.schema();
	  versions.forEach(function (stores, i) {
	    schema = schema.version(i + 1);
	    stores.forEach(function (os) {
	      if (!(sift && EMAIL_BUCKETS.indexOf(os.name) !== -1)) {
	        if (os.drop) {
	          logger.trace('[_getVersionedTreoSchema]: dropping store: ', os.name);
	          schema = schema.dropStore(os.name);
	        } else if (os.keypath) {
	          schema = schema.addStore(os.name, {
	            key: os.keypath
	          });
	        } else {
	          schema = schema.addStore(os.name);
	        }
	        if (os.indexes) {
	          os.indexes.forEach(function (idx) {
	            if (os.drop) {
	              logger.trace('[_getVersionedTreoSchema]: dropping store/index: ' + os.name + '/' + idx);
	              schema = schema.dropIndex(idx);
	            } else {
	              schema = schema.addIndex(idx, idx, {
	                unique: false
	              });
	            }
	          });
	        }
	      }
	    });
	  });
	  return schema;
	}
	function _batchDelete(db, params) {
	  logger.trace('[_batchDelete]: ', params);
	  return new Promise(function (resolve, reject) {
	    db.transaction('readwrite', [params.bucket], function (err, tr) {
	      if (err) {
	        return reject(err);
	      }
	      var store = tr.objectStore(params.bucket);
	      var current = 0;
	      var next = function next() {
	        if (current >= params.keys.length) {
	          return;
	        }
	        var currentKey = params.keys[current];
	        var req;
	        req = store["delete"](currentKey);
	        req.onerror = reject;
	        req.onsuccess = next;
	        current += 1;
	      };
	      tr.onerror = tr.onabort = reject;
	      tr.oncomplete = function () {
	        resolve();
	      };
	      next();
	    });
	  });
	}
	function _batchPut(db, params) {
	  logger.trace('[_batchPut]: ', params);
	  return new Promise(function (resolve, reject) {
	    var count = params.kvs.length;
	    db.transaction('readwrite', [params.bucket], function (err, tr) {
	      if (err) {
	        return reject(err);
	      }
	      var store = tr.objectStore(params.bucket);
	      var current = 0;
	      var next = function next() {
	        if (current >= count) {
	          return;
	        }
	        logger.trace('[_batchPut: put: ', params.kvs[current]);
	        var req;
	        req = store.put(params.kvs[current].value, params.kvs[current].key);
	        req.onerror = reject;
	        req.onsuccess = next;
	        current += 1;
	      };
	      tr.onerror = tr.onabort = reject;
	      tr.oncomplete = function () {
	        resolve();
	      };
	      next();
	    });
	  });
	}
	function _getWithIndexRange(db, params) {
	  logger.trace('[_getWithIndexRange]: ', params);
	  return new Promise(function (resolve, reject) {
	    var store = db.store(params.bucket);
	    var result = [];
	    var found = 0;
	    var iterator = function iterator(cursor) {
	      var ki = params.keys.indexOf(cursor.primaryKey);
	      if (ki !== -1) {
	        logger.trace('[found key: ', cursor.primaryKey);
	        result[ki].value = cursor.value.value;
	        found++;
	      }
	      if (found === params.keys.length) {
	        return done();
	      }
	      cursor["continue"]();
	    };
	    var done = function done(err) {
	      logger.trace('[_getWithIndexRange: result: ', result);
	      err ? reject(err) : resolve(result);
	    };
	    params.keys.forEach(function (k) {
	      result.push({
	        key: k,
	        value: undefined
	      });
	    });
	    store.cursor({
	      index: params.index,
	      range: params.range,
	      iterator: iterator
	    }, done);
	  });
	}
	function _findIn(db, params) {
	  logger.trace('[_findIn]: ', params);
	  return new Promise(function (resolve, reject) {
	    var store = db.store(params.bucket);
	    var result = [];
	    var current = 0;
	    var iterator = function iterator(cursor) {
	      logger.trace('[_findIn]: iterator: ', cursor);
	      if (cursor.key > sKeys[current]) {
	        logger.trace('[_findIn]: cursor ahead: ', cursor.key, sKeys[current]);
	        while (cursor.key > sKeys[current] && current < sKeys.length) {
	          current += 1;
	          logger.trace('[_findIn]: moving to next key: ', cursor.key, sKeys[current]);
	        }
	        if (current > sKeys.length) {
	          logger.trace('[_findIn]: exhausted keys. done.');
	          return done();
	        }
	      }
	      if (cursor.key === sKeys[current]) {
	        logger.trace('[_findIn]: found key: ', cursor.key, cursor.value);
	        result[params.keys.indexOf(sKeys[current])] = {
	          key: cursor.key,
	          value: cursor.value.value
	        };
	        current += 1;
	        current < sKeys.length ? cursor["continue"](sKeys[current]) : done();
	      } else {
	        logger.trace('[_findIn]: continuing to next key: ', sKeys[current]);
	        current < sKeys.length ? cursor["continue"](sKeys[current]) : done();
	      }
	    };
	    var done = function done(err) {
	      logger.trace('[findIn]: result: ', result);
	      err ? reject(err) : resolve(result);
	    };
	    var sKeys = params.keys.slice();
	    sKeys = sKeys.sort(lib.cmp);
	    logger.trace('[findIn: sorted keys: ', sKeys);
	    params.keys.forEach(function (k) {
	      result.push({
	        key: k,
	        value: undefined
	      });
	    });
	    store.cursor({
	      iterator: iterator
	    }, done);
	  });
	}
	function _getAll(db, params, loadValue) {
	  logger.trace('[_getAll]: ', params, loadValue);
	  return new Promise(function (resolve, reject) {
	    var result = [];
	    var keys = [];
	    var store = db.store(params.bucket);
	    var iterator = function iterator(cursor) {
	      var kv = {
	        key: cursor.primaryKey
	      };
	      logger.trace('[_getAll]: cursor', cursor);
	      if (loadValue) {
	        kv.value = cursor.value.value;
	      }
	      if (params.index) {
	        kv.index = cursor.key;
	      }
	      result.push(kv);
	      keys.push(cursor.primaryKey);
	      cursor["continue"]();
	    };
	    var opts = {
	      iterator: iterator
	    };
	    if (params.index) {
	      opts.index = params.index;
	    }
	    if (params.range) {
	      opts.range = params.range;
	    }
	    store.cursor(opts, function (err) {
	      if (err) {
	        reject(err);
	      } else {
	        if (!params.index && !params.range && !loadValue) {
	          logger.trace('[_getAll]: resolving: ', keys);
	          resolve(keys);
	        } else {
	          logger.trace('[_getAll]: resolving: ', result);
	          resolve(result);
	        }
	      }
	    });
	  });
	}

	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
	var _siftGuid = new WeakMap();
	var _dbs = new WeakMap();
	var Storage =              function () {
	  function Storage(dbInfo, ll) {
	    _classCallCheck(this, Storage);
	    this._logger = loglevel.getLogger('RSStorage');
	    this._logger.setLevel(ll || 'warn');
	    if (!dbInfo.accountGuid) {
	      throw new Error('[Storage]: dbInfo.accountGuid undefined');
	    }
	    _siftGuid.set(this, dbInfo.siftGuid);
	    _dbs.set(this, opCreateDb(dbInfo));
	  }
	  _createClass(Storage, [{
	    key: "get",
	    value: function get(params) {
	      this._logger.trace('[Storage::get]: ', params);
	      return opGet(_dbs.get(this), params, _siftGuid.get(this));
	    }
	  }, {
	    key: "getAll",
	    value: function getAll(params) {
	      this._logger.trace('[Storage::getAll]: ', params);
	      return opGetAll(_dbs.get(this), params, _siftGuid.get(this));
	    }
	  }, {
	    key: "getAllKeys",
	    value: function getAllKeys(params) {
	      this._logger.trace('[Storage::getAllKeys]: ', params);
	      return opGetAllKeys(_dbs.get(this), params, _siftGuid.get(this));
	    }
	  }, {
	    key: "getIndex",
	    value: function getIndex(params) {
	      this._logger.trace('[Storage::getIndex]: ', params);
	      return opGetIndex(_dbs.get(this), params, _siftGuid.get(this));
	    }
	  }, {
	    key: "getIndexKeys",
	    value: function getIndexKeys(params) {
	      this._logger.trace('[Storage::getIndexKeys]: ', params);
	      return opGetIndexKeys(_dbs.get(this), params, _siftGuid.get(this));
	    }
	  }, {
	    key: "getWithIndex",
	    value: function getWithIndex(params) {
	      this._logger.trace('[Storage::getWithIndex]: ', params);
	      return opGetWithIndex(_dbs.get(this), params, _siftGuid.get(this));
	    }
	  }, {
	    key: "delUser",
	    value: function delUser(params) {
	      params.bucket = '_user.default';
	      this._logger.trace('[Storage::delUser]: ', params);
	      return opDel(_dbs.get(this), params, _siftGuid.get(this));
	    }
	  }, {
	    key: "getUser",
	    value: function getUser(params) {
	      params.bucket = '_user.default';
	      this._logger.trace('[Storage::getUser]: ', params);
	      return opGet(_dbs.get(this), params, _siftGuid.get(this));
	    }
	  }, {
	    key: "putUser",
	    value: function putUser(params) {
	      params.bucket = '_user.default';
	      this._logger.trace('[Storage::putUser]: ', params);
	      if (!params.kvs || params.kvs.length === 0) {
	        return Promise.reject('[Storage::putUser]: params.kvs undefined');
	      }
	      return opPut(_dbs.get(this), params, false, _siftGuid.get(this));
	    }
	  }, {
	    key: "close",
	    value: function close(cb) {
	      opClose(_dbs.get(this), cb);
	    }
	  }]);
	  return Storage;
	}();
	var InternalStorage =              function (_Storage) {
	  _inherits(InternalStorage, _Storage);
	  var _super = _createSuper(InternalStorage);
	  function InternalStorage(dbInfo, ll) {
	    _classCallCheck(this, InternalStorage);
	    return _super.call(this, dbInfo, ll);
	  }
	  _createClass(InternalStorage, [{
	    key: "get",
	    value: function get(params, siftGuid) {
	      this._logger.trace('[InternalStorage::get]: ', params, siftGuid);
	      return opGet(_dbs.get(this), params, siftGuid || _siftGuid.get(this));
	    }
	  }, {
	    key: "getAll",
	    value: function getAll(params, siftGuid) {
	      this._logger.trace('[InternalStorage::getAll]: ', params, siftGuid);
	      return opGetAll(_dbs.get(this), params, siftGuid || _siftGuid.get(this));
	    }
	  }, {
	    key: "getAllKeys",
	    value: function getAllKeys(params, siftGuid) {
	      this._logger.trace('[InternalStorage::getAllKeys]: ', params, siftGuid);
	      return opGetAllKeys(_dbs.get(this), params, siftGuid || _siftGuid.get(this));
	    }
	  }, {
	    key: "getIndex",
	    value: function getIndex(params, siftGuid) {
	      this._logger.trace('[InternalStorage::getIndex]: ', params, siftGuid);
	      return opGetIndex(_dbs.get(this), params, siftGuid || _siftGuid.get(this));
	    }
	  }, {
	    key: "getIndexKeys",
	    value: function getIndexKeys(params, siftGuid) {
	      this._logger.trace('[InternalStorage::getIndexKeys]: ', params, siftGuid);
	      return opGetIndexKeys(_dbs.get(this), params, siftGuid || _siftGuid.get(this));
	    }
	  }, {
	    key: "getWithIndex",
	    value: function getWithIndex(params, siftGuid) {
	      this._logger.trace('[InternalStorage::getWithIndex]: ', params, siftGuid);
	      return opGetWithIndex(_dbs.get(this), params, siftGuid || _siftGuid.get(this));
	    }
	  }, {
	    key: "cursor",
	    value: function cursor(params, done) {
	      this._logger.trace('[InternalStorage::cursor]: ', params);
	      opCursor(_dbs.get(this).db, params, done);
	    }
	  }, {
	    key: "del",
	    value: function del(params, siftGuid) {
	      this._logger.trace('[InternalStorage::del]: ', params, siftGuid);
	      return opDel(_dbs.get(this), params, siftGuid || _siftGuid.get(this));
	    }
	  }, {
	    key: "deleteDatabase",
	    value: function deleteDatabase() {
	      this._logger.trace('[InternalStorage::deleteDatabase]');
	      return opDeleteDatabase(_dbs.get(this).db);
	    }
	  }, {
	    key: "getDbs",
	    value: function getDbs() {
	      return _dbs.get(this);
	    }
	  }, {
	    key: "put",
	    value: function put(params, raw, siftGuid) {
	      this._logger.trace('[InternalStorage::put]: ', params, raw, siftGuid);
	      return opPut(_dbs.get(this), params, raw, siftGuid || _siftGuid.get(this));
	    }
	  }]);
	  return InternalStorage;
	}(Storage);

	exports.InternalStorage = InternalStorage;
	exports.Storage = Storage;

	Object.defineProperty(exports, '__esModule', { value: true });

}));
